import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import Toolbar from 'material-ui-next/Toolbar'
import withStyles from 'material-ui-next/styles/withStyles'
import { parseQsArg, parseQsId } from '../../../utils'
import WorldsAndCategoriesDropdowns from '../WorldsAndCategoriesDropdowns'

const styles = theme => ({
  toolbar: {
    ...theme.swapick.styles.toolbars.secondaryToolbar,
  },
})

class ItemsICanGetToolbar extends PureComponent {
  makeLinkTo = ({ world, category }) => {
    const { location } = this.props
    return `/me/items/can-get?${qs.stringify({
      item: parseQsId(location, 'item') || undefined,
      world: world ? world.slug : undefined,
      category: category ? category.slug : undefined,
    })}`
  }

  render() {
    const { location, classes } = this.props
    return (
      <Toolbar className={classes.toolbar}>
        <WorldsAndCategoriesDropdowns
          showAllWorlds={true}
          showAllCategories={true}
          worldSlug={parseQsArg(location, 'world')}
          categorySlug={parseQsArg(location, 'category')}
          makeLinkTo={this.makeLinkTo}
        />
      </Toolbar>
    )
  }
}

export default withRouter(withStyles(styles)(ItemsICanGetToolbar))



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/ItemsICanGetToolbar.js